console.log('InteractiveSlideshow');
class InteractiveSlideshow extends HTMLElement { 
  constructor() {
    super();

    this.section = this.closest('.shopify-section');
    this.layoutSection = this.closest('.layout-section');
    this.overlayElement = this.querySelector('.interactive-slideshow-overlay');
    if (this.dataset.animation !== "true") {
      this.layoutSection.style.minHeight = '';
      return;
    }
    this.maxWidth = 35;
    this.animationDistance = 0;

    this.startBufferRatio = 0.1;
    this.endBufferRatio = 0.1;

    // animation state
    this.currentWidth = 0;
    this.targetWidth = 0;

    // RAF / listeners state
    this.rafId = null;
    this.active = false; // whether JS behavior is active (desktop)
    this.scrollHandler = this.onScroll.bind(this);
    this.resizeHandler = this.updateBounds.bind(this);
    this.animate = this.animate.bind(this);

    // media query for desktop
    this.mq = window.matchMedia('(min-width: 1025px)');
    /*
    this.mqListener = (e) => {
      if (e.matches) this.activate();
      else this.deactivate();
    };
    */

    console.log(gsap);
  }

  connectedCallback() {
    if (this.layoutSection && !this.layoutSection.dataset.baseHeight) {
      this.layoutSection.dataset.baseHeight = this.layoutSection.offsetHeight;
      this.layoutSectionHeight = this.layoutSection.offsetHeight;
    }
  
    this.setOverlayWidth(0);
  
    if (this.mq && this.mq.addEventListener) {
      this.mq.addEventListener("change", this.mqListener);
    } else {
      // @ts-ignore – required for old Safari support
      // this.mq.addListener(this.mqListener);
    }

    this.handleOrientationChange = () => {
      // cancel any pending checks
      if (this._orientationTimer) {
        clearTimeout(this._orientationTimer);
      }
    
      // wait for layout + MQ to settle
      this._orientationTimer = setTimeout(() => {
        console.log('orientationchange (delayed)', this.mq.matches);
        this.mq.matches ? this.activate() : this.deactivate();
      }, 150); // 100–200ms is the sweet spot
    };
    window.addEventListener('orientationchange', this.handleOrientationChange);
    if (Shopify.designMode) {
     window.addEventListener('resize', this.handleOrientationChange);
    }
    this.mq.matches ? this.activate() : this.deactivate();

    /*this.contentElement = this.querySelector('[data-content]');

    if(this.contentElement){
      const headerHeight = document.querySelector('header')?.offsetHeight;
      const announcementBarHeight = document.querySelector('announcement-bar')?.offsetHeight;

      const calculatedAnnounceHeader =  headerHeight + announcementBarHeight;
      gsap.set(this.contentElement, { 
        yPercent: -(calculatedAnnounceHeader - 50),
        ease: 'power2.inOut'
       });
    }*/
  }
  
  disconnectedCallback() {
    if (this.mq && this.mq.removeEventListener) {
      this.mq.removeEventListener("change", this.mqListener);
    } else {
      // @ts-ignore – required for old Safari support
      // this.mq.removeListener(this.mqListener);
    }

    window.removeEventListener('orientationchange', this.handleOrientationChange);

  
    this.deactivate();
  }
  
  activate() {
    if (this.active) return;
    this.active = true;

    // safe store baseHeight if not stored
    if (this.overlayElement && this.layoutSection && !this.layoutSection.dataset.baseHeight) {
      this.layoutSection.dataset.baseHeight = this.layoutSection.offsetHeight;
    }

    // attach listeners
    window.addEventListener('scroll', this.scrollHandler, { passive: true });
    window.addEventListener('resize', this.resizeHandler);

    // recalc and start RAF
    this.updateBounds();
    this.rafId = requestAnimationFrame(this.animate);
  }

  deactivate() {
    if (!this.active) {
      // still ensure overlay reset and layout revert just in case
      this.setOverlayWidth(0);
      if (this.overlayElement) this.overlayElement.classList.remove('active');
      if (this.layoutSection && this.layoutSection.dataset.baseHeight) {
        this.layoutSection.style.minHeight = '';
      }
      return;
    }

    this.active = false;
    window.removeEventListener('scroll', this.scrollHandler);
    window.removeEventListener('resize', this.resizeHandler);

    // cancel RAF
    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }

    // reset visual changes
    this.currentWidth = 0;
    this.targetWidth = 0;
    this.setOverlayWidth(0);
    if (this.overlayElement) this.overlayElement.classList.remove('active');

    // revert layout-section min-height so mobile layout isn't affected
    if (this.overlayElement && this.layoutSection && this.layoutSection.dataset.baseHeight) {
      this.layoutSection.style.minHeight = '';
    }
  }

  updateBounds() {
    if (!this.section) return;

    const rect = this.section.getBoundingClientRect();
    this.sectionTop = rect.top + window.scrollY;

    // total scroll length to perform animation
    this.animationDistance = window.innerHeight;

    // if layoutSection base stored, compute total height and set minHeight
    if (this.overlayElement && this.layoutSection && this.layoutSection.dataset.baseHeight) {

      const headerHeight = document.querySelector('header')?.offsetHeight;
      const announcementBarHeight = document.querySelector('announcement-bar')?.offsetHeight;

      const calculatedAnnounceHeader =  headerHeight + announcementBarHeight;
       
      const baseHeight = parseFloat(this.layoutSection.dataset.baseHeight) || this.layoutSection.offsetHeight;
      const totalHeight = baseHeight + this.animationDistance;
      this.layoutSection.style.minHeight = `${totalHeight}px`;
      this.layoutSection.dataset.baseHeight = this.layoutSectionHeight;
    }

    // recalc target on bounds change
    this.onScroll();
  }

  onScroll() {
    if (!this.active) return; // ignore scroll on mobile/inactive state
    if (!this.section || !this.overlayElement) return;

    const scrollY = window.scrollY;

    const start = this.sectionTop;
    const end = start + this.animationDistance;

    const startBuffer = this.animationDistance * this.startBufferRatio;
    const endBuffer = this.animationDistance * this.endBufferRatio;
    // avoid buffer overlap
    let sBuf = startBuffer;
    let eBuf = endBuffer;
    if (sBuf + eBuf >= this.animationDistance) {
      sBuf = 0;
      eBuf = 0;
    }

    const animStart = start + sBuf;
    const animEnd = end - eBuf;

    // Before animation zone
    if (scrollY <= animStart) {
      this.targetWidth = 0;
      return;
    }

    // After animation zone
    if (scrollY >= animEnd) {
      this.targetWidth = this.maxWidth;
      return;
    }

    // Inside animation zone
    const progress = (scrollY - animStart) / (animEnd - animStart);
    this.targetWidth = this.maxWidth * progress;
  }

  animate() {
    // if not active, stop RAF loop
    if (!this.active) {
      this.rafId = null;
      return;
    }

    // smoothing factor — keep your choice (0 < s < 1). smaller = slower smoothing
    const smoothing = 0.8;
    this.currentWidth += (this.targetWidth - this.currentWidth) * smoothing;

    // apply width (float precision maintained)
    this.setOverlayWidth(this.currentWidth);

    // toggle class when crossing threshold (30)
    const threshold = 30;
    if (this.currentWidth >= threshold) {
      this.overlayElement.classList.add('active');
    } else {
      this.overlayElement.classList.remove('active');
    }

    // loop
    this.rafId = requestAnimationFrame(this.animate);
  }

  setOverlayWidth(width) {
    this.style.setProperty('--slider-width', `${width}%`);
    if (this.overlayElement) {
      this.overlayElement.style.setProperty('--slideshow-overlay--width', `${width}%`);
    }
  }
}

if (!customElements.get('interactive-slideshow')) {
  customElements.define('interactive-slideshow', InteractiveSlideshow);
}
